import { ParamsService } from '../../services/params.service';
import { ApiService } from '../../services/api.service';
import { DataService } from '../../services/data.service';
import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';

@Component({
  selector: 'app-address',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.scss']
})
export class AddressComponent implements OnInit {

	@ViewChild('textInput') textInput:ElementRef;
	
	input:string;
	
  constructor(
		public dataService:DataService,
		private api:ApiService,
		public paramsService:ParamsService,
	) { }
	
	
  ngOnInit() {
		
		let input:any = this.textInput.nativeElement;
		
		let options:any = {
			/* 
			bounds: new google.maps.LatLngBounds(
				//70 km around strasbourg
				new google.maps.LatLng(48.242281,7.001274),		//south-west
				new google.maps.LatLng(49.019184,8.528994)		//north-east
			),
			strictBounds: true,
			 */
			
		};
		// options = null;
		
		var autocomplete:any = new google.maps.places.Autocomplete(input, options);
		autocomplete.setFields(['address_components', 'geometry', 'icon', 'name', 'formatted_address']);
		
		
		autocomplete.addListener('place_changed', function() {
			
			var place = autocomplete.getPlace();
			if (!place.geometry) {
				// User entered the name of a Place that was not suggested and
				// pressed the Enter key, or the Place Details request failed.
				console.log("No details available for input: '" + place.name + "'");
				return;
			}
			this.onResult(place);
			
		}.bind(this));
		// debugger;
		
		
	}
	
	focus():void
	{
		setTimeout(function() {
			this.textInput.nativeElement.focus();
		}.bind(this), 500);
	}
	
	
	valid(){
		
		/* 
		this.input;
		this.api.latlng(this.input)
		.subscribe(resp => {
			resp.address = this.input;
			this.paramsService.dispatch('getAddress', resp);
			// debugger;
		}, err => {
			debugger;
		});
		 */
		
	}
	
	onResult(place:any){
		
		let location:{lat:number, lng:number, address:string};
		location = {
			lat:  place.geometry.location.lat(),
			lng:  place.geometry.location.lng(),
			address: place.formatted_address,
		};
		// debugger;
		
		
		this.paramsService.dispatch('getAddress', location);
	}
	
	
	erase(){
		
		this.dataService.showAddress = false;
		this.input = '';
	}

}
